import React, { FC } from "react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import LikeButton from "./LikeButton";
import Prices from "./Prices";
import { Product, PRODUCTS } from "data/data";
import { StarIcon } from "@heroicons/react/24/solid";
import ModalQuickView from "./ModalQuickView";
import ProductStatus from "./ProductStatus";

export interface ProductCardProps {
  className?: string;
  data?: any;
  isLiked?: boolean;
}

const TestimonioCard: FC<ProductCardProps> = ({
  className = "",
  data,
  //isLiked,
}) => {
  const {
    description,
    imageName,
  } = data;
  const [showModalQuickView, setShowModalQuickView] = React.useState(false);

  return (
    <>
      <div className={`nc-ProductCard relative flex flex-col bg-transparent items-center text-center ${className}`}
        data-nc-id="ProductCard"
      >
        <div className="relative flex-shrink-0 bg-slate-50 dark:bg-slate-300 rounded-3xl overflow-hidden z-1 group">
          <div className="w-full h-[420px] overflow-hidden flex justify-center items-center">
            <img
              src={`https://api.yosoymitosis.com/StaticFiles/IndexImg/${imageName}`}
              className="w-full h-full drop-shadow-xl rounded-3xl"
              alt={imageName}
            />
          </div>
        </div>
      </div>

      <ModalQuickView
        show={showModalQuickView}
        onCloseModalQuickView={() => setShowModalQuickView(false)}
      />
    </>
  );
};

export default TestimonioCard;
